import { FaWhatsapp } from "react-icons/fa";

const FloatingChat = () => {
  return (
    <div
      onClick={() =>
        window.open(
          "https://wa.me/2347025600065?text=Hello%20I%20am%20interested%20in%20your%20services",
        )
      }
      className="fixed bottom-4 right-4 z-50 cursor-pointer rounded-full bg-gradient-to-bl from-primary-500 to-primary-900 p-3 shadow-lg transition duration-200 ease-out hover:-translate-y-1 hover:scale-105 sm:bottom-10 sm:right-10"
    >
      <FaWhatsapp size={32} color="white" />
    </div>
  );
};

export default FloatingChat;
